// Open header mega menu onHover script
class MegaMenu extends HTMLElement {
    constructor() {
        super();

        this.items = document.querySelectorAll(".mega-menu");
        this.currentItemIndex;
    }

    connectedCallback() {
        this.items.forEach((item, itemIndex) => {
            const content = item.querySelector('.mega-menu__content');
            item.addEventListener("mouseover", () => {
                if (
                    (this.currentItemIndex === 0 && this.currentItemIndex !== itemIndex) ||
                    (this.currentItemIndex && this.currentItemIndex !== itemIndex)
                ) {
                    this.items[this.currentItemIndex].removeAttribute('open');
                }
                
                this.currentItemIndex = itemIndex;
                item.setAttribute('open', true);
            });
            
            item.addEventListener('mouseleave', (event) => {
                let close = true;
                const closeTimeout = setTimeout(() => {
                    if (close) item.removeAttribute('open');
                }, 200);
                
                content.addEventListener('mouseover', () => {
                    close = false;
                });
                
                item.addEventListener('mouseover', () => {
                    clearTimeout(closeTimeout);
                });
            });
            
            content.addEventListener('mouseleave', () => {
                let forceOpen = false
                Array.from(content.children).forEach(child => {
                    if (child.hasAttribute('forceOpen')) {
                        forceOpen = true
                    }
                })
                
                if (!forceOpen) {
                    item.removeAttribute('open')
                }
            });
        });
    }
}

customElements.define("mega-menu", MegaMenu);
